import React, { useContext ,useEffect} from 'react'
import {Icon} from 'antd'
import  LayoutContext  from '../../LayoutContext'
import {appContentResize }from 'styles/AppCssGlobal';

export const SiderLogo = () =>{
    const { collapsed, onCollapse } = useContext(LayoutContext)

    return (
      <div className="app-index-logo" style={{width:`${collapsed?60:235}px`}}>
        <img src={require('../../../assets/image/company.png')} 
                   className="app-index-logo-img" 
                   hidden={collapsed}
                   alt="logo" />
        <Icon
            className="app-index-logo-icon"
            style={{ right: `${collapsed?18:12}px`}}
            type={collapsed?'menu-unfold':'menu-fold'}
            onClick={()=>onCollapse(!collapsed)}
            title={collapsed?'展开导航':'收起导航'}
          />
      </div>
    )
  }


// WEBPACK FOOTER //
// ./src/layouts/components/SiderMenu/SiderLogo.tsx